import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageLayout from "../components/PageLayout";
import Founder from "../components/Founder";

const FounderPage = () => (
    <PageLayout title="Bobby Philips · Founder · IndoBlitz" testId="founder-page">
        <div className="max-w-7xl mx-auto px-5 lg:px-10 pt-28 lg:pt-32">
            <Link
                to="/about"
                className="inline-flex items-center gap-2 text-ivory/60 hover:text-gold transition-colors text-sm font-mono uppercase tracking-widest"
                data-testid="founder-back"
            >
                <ArrowLeft className="w-4 h-4" /> About IndoBlitz
            </Link>
        </div>
        <Founder />
    </PageLayout>
);

export default FounderPage;
